export const palette = {
  red: {
    main: "#C90304",
    light: "#F28B82",
    dark: "#8B0000",
    contrastText: "#FFFFFF",
  },
  white: {
    main: "#FFFFFF",
    light: "#F5F5F5",
    dark: "#E0E0E0",
    contrastText: "#595959",
  },
  blue: {
    main: "#065B93",
    light: "#F3F6FB",
    dark: "#213252",
    contrastText: "#FFFFFF",
  },
  yellow: {
    main: "#FCBF14",
    light: "#FFE082",
    dark: "#C79100",
    contrastText: "#333333",
  },
  gray: {
    main: "#333333",
    light: "#c0c0c06e",
    dark: "#1A1A1A",
    contrastText: "#FFFFFF",
  },
};
